import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { RouterModule } from '@angular/router';

// Material modules
import { MatIconModule } from '@angular/material/icon';

// Modules
import { UsersModule } from '@modules/users/users.module';
import { RecordsModule } from '@modules/records/records.module';
import { ProjectModule } from '@modules/project/project.module';

// Components
import { LayoutComponent } from './components/layout/layout.component';
import { LeftPanelComponent } from './components/left-panel/left-panel.component';
import { CenterPanelComponent } from './components/center-panel/center-panel.component';



@NgModule({
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,

    // Material
    MatIconModule,

    // Modules
    UsersModule,
    RecordsModule,
    ProjectModule,
  ],
  declarations: [
    LayoutComponent,
    LeftPanelComponent,
    CenterPanelComponent,
  ],
  exports: [
    LayoutComponent,
  ],
})
export class LayoutModule { }
